export default __webpack_public_path__ + "static/nexgen-course-overview-2f958b54a7638042f88ea0bd22db33ff.webp";